import { AnalyticIdentifier } from '@common/neo.tax';
import { RadioForGroup } from '@ui-components/neo.tax';

import { ProjectPurposeImprovedAspect, useAnalyticId } from '@neo.tax/shared';

type ImprovedAspectsOption = Omit<RadioForGroup, 'value'> & { value: ProjectPurposeImprovedAspect };

export const useImprovedAspectsOptions = (): ImprovedAspectsOption[] => {
  const functionId = useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_IMPROVED_FUNCTION);
  const reliabilityId = useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_IMPROVED_RELIABILITY);
  const performanceId = useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_IMPROVED_PERFORMANCE);
  const qualityId = useAnalyticId(AnalyticIdentifier.ENTERPRISE_PROJECT_IMPROVED_QUALITY);

  return [
    {
      label: 'Function',
      value: ProjectPurposeImprovedAspect.Function,
      id: functionId,
    },
    {
      label: 'Reliability',
      value: ProjectPurposeImprovedAspect.Reliability,
      id: reliabilityId,
    },
    {
      label: 'Performance',
      value: ProjectPurposeImprovedAspect.Performance,
      id: performanceId,
    },
    {
      label: 'Quality',
      value: ProjectPurposeImprovedAspect.Quality,
      id: qualityId,
    },
  ];
};
